<template>
  <div>
    <div id="map" style="width: 100%; height: 700px; background: #c9c9c9"></div>
    <div
      v-if="isToggleButtons"
      class="b-vendors__header-btns b-vendors__header-btns--map"
    >
      <v-btn
        :outlined="!onlyPs"
        @click="toggleCustomerType('ps')"
        class="customer-toggle-button mr-2"
        color="blue"
        dark
        depressed
        >Производственные площадки</v-btn
      >
      <v-btn
        :outlined="!onlyCompanies"
        @click="toggleCustomerType('companies')"
        class="customer-toggle-button"
        color="red"
        dark
        depressed
        >Компании</v-btn
      >
    </div>
  </div>
</template>

<script>
import { companiesService } from "@/services/companies-service";

export default {
  name: "CustomersMap",
  data: () => ({
    map: null,
    customerToggler: true,
    onlyPs: false,
    onlyCompanies: false,
    customerType: "",
    objectManager: null
  }),
  props: {
    viewType: {
      type: String,
      default: ""
    },
    mapContainer: {
      type: HTMLElement,
      default: () => {}
    },
    filteredItems: {
      type: Array,
      default: () => []
    },
    center: {
      type: Array,
      default: () => [59.9342802, 30.3350986]
    },
    searchQuery: {
      type: String,
      default: ""
    },
    isToggleButtons: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    viewType(val) {
      if (val === "map") {
        this.map ? this.updateMap() : this.initMap();
      }
    },
    filteredItems() {
      this.updatePlacemarks();
    },
    search() {
      this.updatePlacemarks();
    }
  },
  computed: {
    search() {
      return this.searchQuery || "";
    },
    selectedCustomer() {
      return this.$store.getters.selectedCustomer;
    },
    customers() {
      if (this.customerType === "ps") {
        return this.filteredItems.filter(
          cur =>
            cur.type === "ps" &&
            cur.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
        );
      }
      if (this.customerType === "companies") {
        return this.filteredItems.filter(
          cur =>
            cur.type === "company" &&
            cur.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
        );
      }
      return this.filteredItems.filter(
        cur => cur.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
      );
    },
    placemarks() {
      return this.customers.map(customer => ({
        coords: customer.coords,
        name: customer.name,
        id: customer.id,
        type: customer.type
      }));
    }
  },
  methods: {
    toggleCustomerType(type) {
      if (type === "ps" && !this.onlyPs) {
        this.onlyPs = true;
        this.onlyCompanies = false;
        this.customerType = "ps";
      } else if (type === "companies" && !this.onlyCompanies) {
        this.onlyPs = false;
        this.onlyCompanies = true;
        this.customerType = "companies";
      } else {
        this.onlyPs = false;
        this.onlyCompanies = false;
        this.customerType = "";
      }

      this.$nextTick(this.updatePlacemarks);
    },
    isVisible(element) {
      const computedStyle = window.getComputedStyle(element);
      return computedStyle.display !== "none";
    },
    setSelectedCustomer(customerID) {
      const customer = this.filteredItems.find(
        customer => customerID === customer.id
      );
      if (customer) {
        this.$store.dispatch("setSelectedCustomer", customer);
        this.$emit("show-customer-card");
        this.$emit("change-company", { id: customer.id, name: customer.name });

        companiesService
          .setActiveCompany(customer.id, customer.name)
          .catch(err => {
            throw err;
          });
      }
    },
    updateMap() {
      const intervalId = setInterval(() => {
        if (this.isVisible(this.mapContainer)) {
          this.map.container.fitToViewport(true);
          clearInterval(intervalId);
        }
      }, 100);
    },
    initMap() {
      // eslint-disable-next-line no-undef
      ymaps.ready(this.init);
    },
    updatePlacemarks() {
      if (!this.map) return;
      const objectManager = this.createObjectManager(this.placemarks);
      this.objectManager = objectManager;
      this.map.geoObjects.removeAll();
      this.map.geoObjects.add(objectManager);
      this.updateIntersectCustomers();
    },
    updateIntersectCustomers() {
      const intersectCustomers = [];
      // eslint-disable-next-line no-undef
      this.objectManager.objects.each(object => {
        const objectState = this.objectManager.getObjectState(object.id);
        const bounds = this.map.getBounds();
        if (
          // eslint-disable-next-line no-undef
          ymaps.util.bounds.containsPoint(
            bounds,
            object.geometry.coordinates
          ) &&
          objectState.isShown
        ) {
          const customer = this.filteredItems.find(
            item => item.id === object.id
          );
          intersectCustomers.push(customer);
        }
      });
      this.$emit("intersect-customers", intersectCustomers);
    },
    createObjectManager(data) {
      // eslint-disable-next-line no-undef
      const customBalloonContentLayout = ymaps.templateLayoutFactory.createClass(
        [
          "<ul class='balloon-list'>",
          // Выводим в цикле список всех геообъектов.
          "{% for geoObject in properties.geoObjects %}",
          '<li onclick="setSelectedCustomer({{ geoObject.id }})" data-customer-id="{{ geoObject.id }}" class="balloon-item-{{ geoObject.customerType }}"><span></span><strong data-placemarkid="{{ geoObject.id }}">{{ geoObject.name }}</strong></li>',
          "{% endfor %}",
          "</ul>"
        ].join("")
      );
      // eslint-disable-next-line no-undef
      const objectManager = new ymaps.ObjectManager({
        clusterize: true,
        clusterBalloonContentLayout: customBalloonContentLayout,
        clusterBalloonContentLayoutHeight: 200,
        gridSize: 32,
        clusterDisableClickZoom: true,
        clusterHideIconOnBalloonOpen: false,
        geoObjectHideIconOnBalloonOpen: false,
        clusterIconLayout: "default#pieChart",
        clusterIconPieChartRadius: 25,
        clusterIconPieChartCoreRadius: 10,
        clusterIconPieChartStrokeWidth: 4
      });

      const placemarks = {
        features: [],
        type: "FeatureCollection"
      };

      data.forEach(placemark => {
        placemarks.features.push({
          geometry: {
            coordinates: [placemark.coords[0], placemark.coords[1]],
            type: "Point"
          },
          options: {
            preset: "islands#blackDotIcon",
            iconColor: placemark.type === "company" ? "#ED4543" : "#1E98FF"
          },
          id: placemark.id,
          name: placemark.name,
          customerType: placemark.type,
          object_id: placemark.id,
          properties: {
            hintContent: `<strong>${placemark.name}</strong>`
          },
          type: "Feature"
        });
      });

      const onObjectClick = e => {
        const customerID = e.get("objectId");

        this.setSelectedCustomer(customerID);
      };

      objectManager.add(placemarks);
      objectManager.objects.events.add("click", onObjectClick);
      objectManager.clusters.balloon.events.add("open", () =>
        this.$emit("update-balloon-dot", this.selectedCustomer.id)
      );

      return objectManager;
    },
    init() {
      // eslint-disable-next-line no-undef
      this.map = new ymaps.Map("map", {
        center: this.center,
        zoom: 3,
        controls: ["zoomControl", "searchControl"]
      });

      this.map.events.add("boundschange", () => {
        this.updateIntersectCustomers();
      });

      this.updatePlacemarks();
    }
  },
  created() {
    window.setSelectedCustomer = this.setSelectedCustomer;
  }
};
</script>

<style lang="scss">
.customer-toggle-button {
  background-color: #ffffff;
}
.balloon-list {
  max-height: 200px;
  overflow-y: scroll;
  list-style: none !important;
  padding-left: 0 !important;

  li {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    cursor: pointer;

    span {
      display: inline-block;
      position: relative;
      width: 18px;
      height: 18px;
      margin-right: 6px;
      border: 2px solid;
      border-radius: 50%;
    }

    strong {
      display: inline-block;
    }

    &.balloon-item-ps {
      span {
        border-color: #2096f4;
      }
    }

    &.balloon-item-ps.active {
      span {
        border-color: #2096f4;

        &::before {
          position: absolute;
          content: "";
          width: 10px;
          height: 10px;
          top: 50%;
          left: 50%;
          transform: translate3d(-50%, -50%, 0);
          border-radius: 50%;
          background-color: #2096f4;
        }
      }

      strong {
        color: #2096f4;
      }
    }

    &.balloon-item-company {
      span {
        border-color: #f44335;
      }
    }

    &.balloon-item-company.active {
      span {
        border-color: #f44335;

        &::before {
          position: absolute;
          content: "";
          width: 10px;
          height: 10px;
          top: 50%;
          left: 50%;
          transform: translate3d(-50%, -50%, 0);
          border-radius: 50%;
          background-color: #f44335;
        }
      }

      strong {
        color: #f44335;
      }
    }
  }
}
</style>
